/**
 * @generated SignedSource<<51ee56fdcd4c1dd3f2fde1e621f5d25c>>
 * @relayHash 49e56d172287bb583e6143235343cde8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d750cd41b6bb77afc03be232afda9cb69b1eb32a92b3781ed76c1e028da91166

import type { ConcreteRequest } from 'relay-runtime';
export type BoardTmpMatureExampleGupsAnalyticsQuery$variables = {
  cloudId: string;
  includeGups: boolean;
};
export type BoardTmpMatureExampleGupsAnalyticsQuery$data = {
  readonly growthUnifiedProfile_getUnifiedProfile?: {
    readonly onboardingContext: {
      readonly jira: {
        readonly matureExampleProjectIds: ReadonlyArray<string | null> | null;
      } | null;
    } | null;
  } | null;
};
export type BoardTmpMatureExampleGupsAnalyticsQuery = {
  response: BoardTmpMatureExampleGupsAnalyticsQuery$data;
  variables: BoardTmpMatureExampleGupsAnalyticsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeGups"
  }
],
v1 = [
  {
    "condition": "includeGups",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "tenantId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "GrowthUnifiedProfileResult",
        "kind": "LinkedField",
        "name": "growthUnifiedProfile_getUnifiedProfile",
        "plural": false,
        "selections": [
          {
            "concreteType": "GrowthUnifiedProfileOnboardingContext",
            "kind": "LinkedField",
            "name": "onboardingContext",
            "plural": false,
            "selections": [
              {
                "concreteType": "GrowthUnifiedProfileJiraOnboardingContext",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "matureExampleProjectIds"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "BoardTmpMatureExampleGupsAnalyticsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BoardTmpMatureExampleGupsAnalyticsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "d750cd41b6bb77afc03be232afda9cb69b1eb32a92b3781ed76c1e028da91166",
    "metadata": {},
    "name": "BoardTmpMatureExampleGupsAnalyticsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4899112bd23551c908c9d2c360feb0f2";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
